module.exports = __webpack_public_path__ + "static/media/icon-144.b0bd4526.png";